import * as Scrivito from "scrivito";
import { localizeAttrList } from "^/utils/localizeAttribute";

Scrivito.provideEditingConfig("Download", {
  attributes: localizeAttrList(["tags", "title"], "Download"),
  properties: ["title", "tags"],
  validations: [
    [
      "title",
      (title) => {
        if (title === "") {
          return "No title is set for this download.";
        }
        return null;
      },
    ],
  ],
});
